var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"c874006"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/frontend-production";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import { getCookie } from '@functions/cookies';
import * as Sentry from '@sentry/nextjs';
import { ECookie } from '@settingsCookies/hooks/useCookies/useCookies.enums';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
	dsn: SENTRY_DSN,
	integrations: [
		// Add browser profiling integration to the list of integrations
		new Sentry.BrowserProfilingIntegration(),
		new Sentry.BrowserTracing()
	],
	// Adjust this value in production, or use tracesSampler for greater control
	tracesSampleRate: 0.8,
	environment: process.env.SENTRY_BUILD_ENV,
	release: process.env.BUILD_ID,
	beforeSend(event) {
		const sentryConsent = !!getCookie(ECookie.sentry);

		// Modify or drop the event here
		if (!sentryConsent || event.transaction === '/api/healthz' || event.transaction === 'GET /api/healthz') {
			return null;
		}

		return event;
	}
});
